import styled from 'styled-components'

export const ModalDetails = styled.span`
  white-space: pre-wrap;
`
